import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useTranslation } from "react-i18next";

type CertificateModalProps = {
  open: boolean;
  setOpen: () => void;
  addRecommendationCertificate: () => void;
};

export default function CertificateModal(props: CertificateModalProps) {
  const { open, setOpen, addRecommendationCertificate } = props;
  const cancelButtonRef = useRef(null);
  const LocalBasePath = "page.supervisor.student";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4  sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5  shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                <div className="sm:flex  sm:items-start">
                  <div className="flex flex-col">
                    <Dialog.Title
                      as="h3"
                      className="text-sm  font-medium  text-gray-700"
                    >
                      {t("recommendationKhetam")}
                    </Dialog.Title>
                    <div className="py-4 ">
                      <p className="text-sm text-gray-500">
                        {t("recommendationKhetmaDesc")}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4  flex  flex-col-reverse  sm:flex-row">
                  <button
                    type="button"
                    className="mt-3 inline-flex w-full  mb-2 sm:mb-0 justify-center rounded-md bg-white px-3 py-2 text-sm font-medium text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                    onClick={() => setOpen()}
                    ref={cancelButtonRef}
                  >
                    {t("cancel")}
                  </button>
                  <button
                    type="button"
                    className="inline-flex w-full justify-center rounded-md bg-brandblue-600 px-3 py-2 text-sm font-medium text-white shadow-sm hover:bg-brandblue-500 sm:mx-3 sm:w-auto"
                    onClick={() => addRecommendationCertificate()}
                  >
                    {t("send")}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
